import { render, staticRenderFns } from "./SettingsWebhooks.vue?vue&type=template&id=73a77efa"
import script from "./SettingsWebhooks.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a77efa')) {
      api.createRecord('73a77efa', component.options)
    } else {
      api.reload('73a77efa', component.options)
    }
    module.hot.accept("./SettingsWebhooks.vue?vue&type=template&id=73a77efa", function () {
      api.rerender('73a77efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsWebhooks.vue"
export default component.exports